import React from 'react';
import { toast } from 'react-toastify';
import { Trans, useTranslation } from 'react-i18next';

import {
    ButtonGroup,
    DaButton,
    Text,
    TrashIcon,
    ModalControl,
    ArrowRoundTopLeftIcon,
} from '@paygreen/paygreen-ui';
import { deleteUserProject } from '../../domains/projects/service';
import { useAPIError } from '../../context';

import { ModalForm } from '../../components';

const ConfirmDeleteModalProject = ({
    userProjects,
    project: { idProject, name },
    projects,
    setProjects,
    isOpen,
    fetchData,
    setIsLoading,
}) => {
    const { t } = useTranslation();
    const { addError } = useAPIError();

    const handleRemoveProject = async () => {
        try {
            setIsLoading(true);

            await deleteUserProject(idProject);

            if (userProjects) {
                const updatedProject = projects.filter((item) => {
                    return item.idProject !== idProject;
                });
                setProjects(updatedProject);
                setIsLoading(false);
            } else {
                const index = projects.findIndex(
                    (item) => item.idProject === idProject,
                );

                const copyArr = [...projects];

                copyArr[index].isUserProject = false;

                setProjects(copyArr);
                setIsLoading(false);
            }
            fetchData();
        } catch (error) {
            addError(
                error?.response?.data.detail,
                error?.response?.data.status,
            );

            setIsLoading(false);
        }

        toast(
            <Text colorPallet="theme" textSize="xs">
                <Trans
                    i18nKey="contributions.globalView.globalCard.removeProjectMessage"
                    values={{ project: name }}
                    components={{ bold: <strong /> }}
                >
                    Le projet <bold>{{ name }}</bold> a bien été retiré de vos
                    projets 🎉
                </Trans>
            </Text>,
        );
    };

    return (
        <ModalForm hasCloseCross={false} blockWidth="md" isOpen={isOpen}>
            <Text marginBottom="xs">
                <Trans
                    i18nKey="contributions.globalView.globalCard.modalDescription"
                    values={{ name: name }}
                    components={{
                        bold: <strong />,
                        italic: <i />,
                    }}
                >
                    Êtes-vous sûr(e) de vouloir retirer
                    <bold>
                        <i>{name}</i>
                    </bold>
                    de vos projets carbone ?
                </Trans>
            </Text>

            <Text textSize="sm" marginBottom="xs">
                {t('contributions.globalView.globalCard.modalInfo')}
            </Text>

            <ButtonGroup marginBottom="sm" marginTop="sm">
                <ModalControl hasOnClickControl>
                    <button type="button">
                        <DaButton
                            colorPallet="theme"
                            colorTheme="secondary"
                            buttonStyle="line"
                        >
                            <ArrowRoundTopLeftIcon /> {t('form.button.cancel')}
                        </DaButton>
                    </button>
                    <button type="button">
                        <DaButton
                            colorPallet="status"
                            type="button"
                            colorStatus="danger"
                            onClick={handleRemoveProject}
                        >
                            <TrashIcon />
                            {t(
                                'contributions.globalView.globalCard.confirmRemoveProject',
                            )}
                        </DaButton>
                    </button>
                </ModalControl>
            </ButtonGroup>
        </ModalForm>
    );
};

export default ConfirmDeleteModalProject;
